import { assign, identity, isString } from 'lodash';
import { parse } from 'content-type';
import { handler } from 'fetch-plus-json';
import { ACCEPT, CONTENT_TYPE } from 'http-header-fields';

const isJson = type => type && parse(type).type === 'application/json';

export default (settings = {}) => ({ options }) => {
  if (isJson(options.headers[CONTENT_TYPE]) && !isString(options.body)) {
    assign(options, {
      body: JSON.stringify(options.body),
    });
  }

  return isJson(options.headers[ACCEPT])
    ? handler(settings)
    : identity;
};



// WEBPACK FOOTER //
// ./src/Api/middleware/json.js